import { HttpStatusCode } from '@angular/common/http';

import { createAction, props, union } from '@ngrx/store';

import {
  CostComponentSplitItem,
  SchaefflerBomIdentifier,
  SchaefflerBomItem,
} from '@cdba/shared/models';
import {
  VitescoBomIdentifier,
  VitescoBomItem,
} from '@cdba/shared/models/vitesco-bom-item.model';

export const loadVitescoBom = createAction(
  '[Detail] Load Vitesco BOM',
  props<{ bomIdentifier: VitescoBomIdentifier }>()
);

export const loadVitescoBomSuccess = createAction(
  '[Detail] Load Vitesco BOM Success',
  props<{ items: VitescoBomItem[] }>()
);

export const loadVitescoBomFailure = createAction(
  '[Detail] Load Vitesco BOM Failure',
  props<{ errorMessage: string; statusCode: HttpStatusCode }>()
);

export const loadSchaefflerBom = createAction(
  '[Detail] Load Schaeffler BOM',
  props<{ bomIdentifier: SchaefflerBomIdentifier }>()
);

export const loadSchaefflerBomSuccess = createAction(
  '[Detail] Load Schaeffler BOM Success',
  props<{ items: SchaefflerBomItem[] }>()
);

export const loadSchaefflerBomFailure = createAction(
  '[Detail] Load Schaeffler BOM Failure',
  props<{ errorMessage: string; statusCode: HttpStatusCode }>()
);

export const selectBomItem = createAction(
  '[Detail] Select BOM Item',
  props<{ rowId: string }>()
);

export const loadCostComponentSplit = createAction(
  '[Detail] Load Cost Component Split',
  props<{ bomIdentifier: SchaefflerBomIdentifier }>()
);

export const loadCostComponentSplitSuccess = createAction(
  '[Detail] Load Cost Component Split Success',
  props<{ items: CostComponentSplitItem[] }>()
);

export const loadCostComponentSplitFailure = createAction(
  '[Detail] Load Cost Component Split Failure',
  props<{ errorMessage: string; statusCode: HttpStatusCode }>()
);

export const toggleSplitType = createAction('[Detail] Toggle Split Type');

const _all = union({
  selectBomItem,
  loadSchaefflerBom,
  loadSchaefflerBomSuccess,
  loadSchaefflerBomFailure,
  loadVitescoBom,
  loadVitescoBomSuccess,
  loadVitescoBomFailure,
  loadCostComponentSplit,
  loadCostComponentSplitSuccess,
  loadCostComponentSplitFailure,
  toggleSplitType,
});

export type BomActions = typeof _all;
